import { Block } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { observer } from "mobx-react";
import React, { memo, useEffect } from "react";
import { useStore } from "app/stores";
import TableComponent from "app/common/Component/Table/TableComponent";
import { Grid } from "@material-ui/core";
import { getDateTime } from "app/common/LocalFunction";

const ProductHistoryPopup = ({
  open,
  handleClose,
  // resetPopupStore,
}) => {

  const {
    dataProductHistory,
    searchProductHistory,
    resetPopupStore,
    handleChangeFormSearchProductHistory,
    fetchPagingProductHistory,
    selectProductOrderId
  } = useStore().patientManagementStore.registerProductStore;

  useEffect(() => {
    if (selectProductOrderId) {
      handleChangeFormSearchProductHistory({
        ...searchProductHistory,
        drugOrderId: selectProductOrderId,
      });
      // fetchPagingProductHistory();
    }
  }, [selectProductOrderId]);

  const renderStaffRevenue = (staffRevenueValue) => {
    if (typeof staffRevenueValue !== 'string') return null;

    const lines = staffRevenueValue.trim().split('\n');

    const items = [];
    for (let i = 0; i < lines.length; i += 2) {
      const infoLine = lines[i];
      const amountLine = lines[i + 1] || '';
      items.push({ infoLine, amountLine });
    }

    return (
      <div>
        {items.map((item, index) => (
          <div key={index}>
            <div><strong>{item.infoLine}</strong></div>
            <div>{item.amountLine}</div>
          </div>
        ))}
      </div>
    );
  };


  return (
    <PopupForm
      open={open}
      size="xl"
      handleClose={handleClose}
      title={`Lịch sử chỉnh sửa sản phẩm`}
      action={({ isSubmitting, setFieldValue, submitForm }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TableComponent
                titleNodata={"noData"}
                //showOrdinalNumbers
                data={dataProductHistory?.content || []}
                name="ListProductHistory"
                columns={[
                  {
                    field: "drugOrderName",
                    title: "Tên sản phẩm đăng ký",
                    align: "right",
                    render: (val) => (val?.drugOrderName),
                  },
                  {
                    field: "drugName",
                    title: "Tên sản phẩm",
                    align: "right",
                    render: (val) => (val?.drugCode + " - " + val?.drugName),
                  },
                  {
                    field: "soldQuantity",
                    title: "Số lượng",
                    align: "right",
                    render: (val) => (val?.soldQuantity),
                  },
                  {
                    field: "price",
                    title: "Giá",
                    align: "right",
                    render: (val) => (val?.price),
                  },
                  {
                    field: "percentDiscount",
                    title: "% giảm giá",
                    align: "right",
                    render: (val) => (val?.percentDiscount),
                  },
                  {
                    title: 'Phân bổ doanh thu',
                    field: 'staffRevenueValue',
                    align: "left",
                    render: (val) => renderStaffRevenue(val?.staffRevenueValue),
                  },
                  {
                    field: "patientName",
                    title: "Khách hàng",
                    align: "right",
                    render: (val) => (val?.patientCode + " - " + val?.patientName),
                  },
                  {
                    field: "personChange",
                    title: "Người chỉnh sửa",
                    align: "right",
                    render: (val) => (val?.personChange),
                  },
                  {
                    field: "createdBy",
                    title: "Tên tài khoản",
                    align: "right",
                    render: (val) => (val?.createdBy),
                  },
                  {
                    field: "createDate",
                    title: "Thời gian chỉnh sửa",
                    align: "right",
                    render: (val) => getDateTime(val?.createDate),
                  }
                ]}
                dataPagination={{
                  pageIndex: searchProductHistory?.pageIndex,
                  pageSize: searchProductHistory?.pageSize,
                  totalElements: dataProductHistory?.totalElements,
                  totalPages: dataProductHistory?.totalPages,
                  setPageIndex: (pageIndex) =>
                    handleChangeFormSearchProductHistory({ pageIndex }),
                  setPageSize: (pageSize) =>
                    handleChangeFormSearchProductHistory({ pageSize }),
                }}
              />
            </Grid>
          </Grid>
        );
      }}
    </PopupForm>
  );
}


export default memo(observer(ProductHistoryPopup));
